import { render, staticRenderFns } from "./PsConfigurationPanel.vue?vue&type=template&id=e10e4542&scoped=true&"
import script from "./PsConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationPanel.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationPanel.vue?vue&type=style&index=0&id=e10e4542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10e4542",
  null
  
)

export default component.exports